import { TICKETS_FULL_SIZE_PATH } from '../../../constants';
import {
    createApplePayPaymentRequestIfExpressCheckout,
    startApplePaySession,
} from '../../applePay';
import { trackTicketsPageSubmit } from '../../eventAnalytics';
import { ADD_TO_CART, triggerTrackingPixelAction } from '../../pixelAnalytics';

/**
 * Dispatch the correct actions when clicking Express Checkout (ApplePay button) from the Ticket Selection Page
 */
export const startExpressCheckoutApplePaySession = () => async (dispatch) => {
    dispatch(triggerTrackingPixelAction(ADD_TO_CART));
    dispatch(trackTicketsPageSubmit(TICKETS_FULL_SIZE_PATH));
    await dispatch(createApplePayPaymentRequestIfExpressCheckout());
    dispatch(startApplePaySession(true));
};
